<template>
  <div>
    <div class="m-1" v-if="user_id.nav_bar">
        <navigation-bar
          v-bind:skin="skin"
          v-bind:translation="translation"
          v-bind:language="language"
          v-bind:navigation="[{name:'HISTORIAL',link:''}]"
        />
    </div>
    <div class="m-1 p-1 text-center" :style="skin.qbet.fondo3">
        <div class="row p-2">
            <div class="col-12 col-lg-4"><input class="form-control p-1 mb-1" :placeholder="translate('ticket_id')" type="number" v-model="ticket_id"/></div>
            <div class="col-12 col-lg-4"><date-picker v-model="date_range" type="date" range placeholder="" style="max-width:100%;" class="mb-2" ></date-picker></div>
            <div class="col-12 col-lg-4"><button @click="get_tracking('from_scratch')" :style="skin.qbet.booking_btn" class="p-1 text-center mb-2" style="width:50%;color:white" :disabled="loading_tracking">{{translate("show")}}</button></div>
        </div>
        <div :style="hoverCss" class="row px-2">
            <div 
                :class="ticket_status==-1?'hover':''" 
                @click="select_status(-1)" style="cursor:pointer;min-width:100px;" 
                id="allTickets"
                @mouseover="ticket_status==-1?'':hover('allTickets')" 
                @mouseleave="ticket_status==-1?'':hover2('allTickets')" 
                :style="skin.casino.button" class="m-1 mx-0 mx-0 p-1 text-center col-4 col-lg-2">{{translate("all")}}
            </div>
            <div 
                :class="ticket_status==1?'hover':''" 
                @click="select_status(1)" style="cursor:pointer;min-width:100px;" 
                id="pendingTickets" 
                @mouseover="ticket_status==1?'':hover('pendingTickets')" 
                @mouseleave="ticket_status==1?'':hover2('pendingTickets')" 
                :style="skin.casino.button" class="m-1 mx-0 p-1 text-center col-4 col-lg-2">{{translate("pendings")}}
            </div>
            <div 
                :class="ticket_status==2?'hover':''" 
                @click="select_status(2)" style="cursor:pointer;min-width:100px;" 
                id="wonTickets" 
                @mouseover="ticket_status==2?'':hover('wonTickets')" 
                @mouseleave="ticket_status==2?'':hover2('wonTickets')" 
                :style="skin.casino.button" class="m-1 mx-0 p-1 text-center col-4 col-lg-2">{{translate("won")}}
            </div>
            <div 
                :class="ticket_status==4?'hover':''" 
                @click="select_status(4)" style="cursor:pointer;min-width:100px;" 
                id="lostTickets" 
                @mouseover="ticket_status==4?'':hover('lostTickets')" 
                @mouseleave="ticket_status==4?'':hover2('lostTickets')" 
                :style="skin.casino.button" class="m-1 mx-0 p-1 text-center col-4 col-lg-2">{{translate("losses")}}
            </div>
            <div 
                :class="ticket_status==7?'hover':''" 
                @click="select_status(7)" style="cursor:pointer;min-width:100px;" 
                id="cashoutTickets" 
                @mouseover="ticket_status==7?'':hover('cashoutTickets')" 
                @mouseleave="ticket_status==7?'':hover2('cashoutTickets')" 
                :style="skin.casino.button" class="m-1 mx-0 p-1 text-center col-4 col-lg-2">CashOut
            </div>
            <div 
                :class="ticket_status==0?'hover':''" 
                @click="select_status(0)" style="cursor:pointer;min-width:100px;" 
                id="cancelledTickets" 
                @mouseover="ticket_status==0?'':hover('cancelledTickets')" 
                @mouseleave="ticket_status==0?'':hover2('cancelledTickets')" 
                :style="skin.casino.button" class="m-1 mx-0 p-1 text-center col-4 col-lg-2">{{translate("returned")}}
            </div>
        </div>
    </div>
    <div v-if="Object.keys(bet_tracking.tickets).length>0" class="py-1 m-1" :style="skin.qbet.fondo3" style="min-height:76vh;">
        <div class="p-2 text-center" v-if="user.user_data.data">
            <!-- <span>{{ user.user_data.data.rol=='RESELLER' ? translate('sold') : translate('staked') }} {{ sold }}</span>&nbsp;&nbsp;
            <span>{{ user.user_data.data.rol=='RESELLER' ? translate('paid') : translate('won2') }} {{ paid }}</span>&nbsp;&nbsp;
            <span v-if="user.user_data.data.rol=='RESELLER'">Total: {{ (sold - paid).toFixed(2) }}</span> -->
            <br>
            <span>{{ user.user_data.data.rol=='RESELLER' ? translate('staked') : translate('staked') }} 
                {{ adminData.apostado ? Number(adminData.apostado).toFixed(2) : '0.00' }}</span>&nbsp;&nbsp;
            <span>{{ user.user_data.data.rol=='RESELLER' ? translate('won') : translate('won') }} 
                {{ adminData.ganado ? Number(adminData.ganado).toFixed(2) : '0.00' }}</span>&nbsp;&nbsp;
            <span>{{ user.user_data.data.rol=='RESELLER' ? translate('paid') : translate('paid') }} 
                {{ adminData.pagado ? Number(adminData.pagado).toFixed(2) : '0.00' }}</span>&nbsp;&nbsp;
            <span>{{ user.user_data.data.rol=='RESELLER' ? translate('total') : translate('total') }} 
                {{ adminData.total ? Number(adminData.total).toFixed(2) : '0.00' }}</span>&nbsp;&nbsp;

            <span @click="printAdminData">
                <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff" stroke-width="0.00024000000000000003"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M18 16.75H16C15.8011 16.75 15.6103 16.671 15.4697 16.5303C15.329 16.3897 15.25 16.1989 15.25 16C15.25 15.8011 15.329 15.6103 15.4697 15.4697C15.6103 15.329 15.8011 15.25 16 15.25H18C18.3315 15.25 18.6495 15.1183 18.8839 14.8839C19.1183 14.6495 19.25 14.3315 19.25 14V10C19.25 9.66848 19.1183 9.35054 18.8839 9.11612C18.6495 8.8817 18.3315 8.75 18 8.75H6C5.66848 8.75 5.35054 8.8817 5.11612 9.11612C4.8817 9.35054 4.75 9.66848 4.75 10V14C4.75 14.3315 4.8817 14.6495 5.11612 14.8839C5.35054 15.1183 5.66848 15.25 6 15.25H8C8.19891 15.25 8.38968 15.329 8.53033 15.4697C8.67098 15.6103 8.75 15.8011 8.75 16C8.75 16.1989 8.67098 16.3897 8.53033 16.5303C8.38968 16.671 8.19891 16.75 8 16.75H6C5.27065 16.75 4.57118 16.4603 4.05546 15.9445C3.53973 15.4288 3.25 14.7293 3.25 14V10C3.25 9.27065 3.53973 8.57118 4.05546 8.05546C4.57118 7.53973 5.27065 7.25 6 7.25H18C18.7293 7.25 19.4288 7.53973 19.9445 8.05546C20.4603 8.57118 20.75 9.27065 20.75 10V14C20.75 14.7293 20.4603 15.4288 19.9445 15.9445C19.4288 16.4603 18.7293 16.75 18 16.75Z" fill="#ffffff8a"></path> <path d="M16 8.75C15.8019 8.74741 15.6126 8.66756 15.4725 8.52747C15.3324 8.38737 15.2526 8.19811 15.25 8V4.75H8.75V8C8.75 8.19891 8.67098 8.38968 8.53033 8.53033C8.38968 8.67098 8.19891 8.75 8 8.75C7.80109 8.75 7.61032 8.67098 7.46967 8.53033C7.32902 8.38968 7.25 8.19891 7.25 8V4.5C7.25 4.16848 7.3817 3.85054 7.61612 3.61612C7.85054 3.3817 8.16848 3.25 8.5 3.25H15.5C15.8315 3.25 16.1495 3.3817 16.3839 3.61612C16.6183 3.85054 16.75 4.16848 16.75 4.5V8C16.7474 8.19811 16.6676 8.38737 16.5275 8.52747C16.3874 8.66756 16.1981 8.74741 16 8.75Z" fill="#ffffff8a"></path> <path d="M15.5 20.75H8.5C8.16848 20.75 7.85054 20.6183 7.61612 20.3839C7.3817 20.1495 7.25 19.8315 7.25 19.5V12.5C7.25 12.1685 7.3817 11.8505 7.61612 11.6161C7.85054 11.3817 8.16848 11.25 8.5 11.25H15.5C15.8315 11.25 16.1495 11.3817 16.3839 11.6161C16.6183 11.8505 16.75 12.1685 16.75 12.5V19.5C16.75 19.8315 16.6183 20.1495 16.3839 20.3839C16.1495 20.6183 15.8315 20.75 15.5 20.75ZM8.75 19.25H15.25V12.75H8.75V19.25Z" fill="#ffffff8a"></path> </g></svg>
             </span>
        </div>
        <div v-if="filtered_tracking.length>0">
            <tracking
                v-for="(ticket, index) in filtered_tracking" :key="ticket.id"
                v-bind:ticket_data="ticket"
                v-bind:Skin="skin"
                v-bind:language="language"
                v-bind:translation="translation"
                v-bind:index="index"
                v-bind:currentOdds="bet_tracking.currentOdds"
                v-bind:source="source"
            />
        </div>
        <div v-else class="text-center p-3">
            {{translate("no_search_results")}}
        </div>
    </div>
    <div v-else style="width:100%" class="text-center p-2" :style="skin.qbet.fondo3">
        <div class="spinner-border" :style="skin.loader" role="status">
        <span class="visually-hidden">Loading...</span>
        </div>
    </div>
  </div>
</template>

<script>
import navigationBar from './navigation_bar.vue';
import tracking from '../../main_bet/tracking.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es/es';
export default {
    name:"main_records",
    props:['skin','translation','language','user_id','source'],
    components:{navigationBar,tracking,DatePicker},
    data(){
        return {
            interval:"",
            bet_tracking:{
                "tickets":{},
                "currentOdds":{}
            },
            loading_tracking:false,
            filtered_tracking:{},
            fullAdminData: {},
            ticket_status:-1,
            date_range:[],
            ticket_id:"",
            sold:0,
            paid:0,
            apostado: 0,
            ganado: 0,
            pagado: 0,
            total: 0,
        }
    },
    computed:{
        adminData() {
            this.ganado = 0;
            this.apostado = 0;
            this.pagado = 0;
            this.total = 0;
            let baseData = this.filtered_tracking;
            // console.log("full admin data =", this.fullAdminData)
            // console.log("base data de reporte =", baseData);
            this.apostado = this.fullAdminData.vendido;
            for (let i = 0; i < baseData.length; i++) {
                // si es ganador debe acumular el posible win
                if (baseData[i].status == 2 || baseData[i].status == 3 || baseData[i].status == 5) {
                    this.ganado = this.ganado + baseData[i].possible_win;
                }
            }
            this.pagado = this.fullAdminData.pagado;
            this.total = this.apostado - this.pagado
            return {
                    apostado: this.apostado, 
                    ganado: this.ganado, 
                    pagado: this.pagado, 
                    total: this.total
                };
        },
        hoverCss(){
            return {
                '--fondoH':this.$props.skin.prematch_all_odds.hover_fondo,
                '--textH':this.$props.skin.prematch_all_odds.hover_text,
            }
        },
        user(){
            return this.$store.getters['getUserData'];
        },
    },
    methods:{
        printAdminData() {
        const formatFecha = (fecha) => {
            let date = new Date(fecha);
            return date.toLocaleDateString("es-ES", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            });
        };
        const printAdminDataMessage = {
            "action": "printReportBetsw3",
            "data": {
                "startDate": this.date_range?.[0] ? formatFecha(this.date_range[0]) : "N/A",
                "endDate": this.date_range?.[1] ? formatFecha(this.date_range[1]) : "N/A",
                "betAmount": this.apostado ? Number(this.apostado).toFixed(2): '0.00',
                "winAmount": this.ganado ? Number(this.ganado).toFixed(2): '0.00',
                "paidAmount": this.pagado ? Number(this.pagado).toFixed(2): '0.00',
                "total": this.total ? Number(this.total).toFixed(2): '0.00'
            }
        }
        console.log(printAdminDataMessage);
        window.parent.postMessage(printAdminDataMessage, '*');
    },
    async get_tracking(type){
            this.ganado = 0;
            this.pagado = 0;
            this.total = 0;
            this.apostado = 0;
            let dateFrom =this.date_range[0];
            let dateTo = this.date_range[1];
            let data = {
                from:Math.floor(dateFrom.getTime()/1000),
                to:Math.floor(dateTo.getTime()/1000),
            }
            if(type=="from_scratch"){
                this.bet_tracking = {
                    "tickets":{},
                    "currentOdds":{}
                }
            }
            if(this.$props.user_id.id){
                data['user_id'] = this.$props.user_id.id;
            }
            if(this.ticket_id!=""){
                data['bet_id'] = this.ticket_id;
            } 
            let tracking = await this.$store.dispatch('getTracking',data);
            // console.log("tracking data 11111111111=", tracking.data);
            this.fullAdminData = tracking.data;
            let odd_ids = [];
            this.sold = parseFloat(tracking.data.vendido ? tracking.data.vendido : 0).toFixed(this.$props.skin.qBet_config.decimalsQty);
            this.paid = parseFloat(tracking.data.pagado ? tracking.data.pagado : 0).toFixed(this.$props.skin.qBet_config.decimalsQty);
            tracking.data.bets.forEach(pendingT=>{
                pendingT.events.forEach(odd=>{
                    if(odd.status==1){
                        odd_ids.push(odd.id);
                    }
                })
            })
            odd_ids = [...new Set(odd_ids)];
            let currentOddData = await this.$store.dispatch('getOddData',odd_ids);
            tracking.data.bets = tracking.data.bets.reverse()
            this.bet_tracking.tickets = tracking;
            this.bet_tracking.currentOdds = currentOddData;
            let filtered = [];
            if(this.ticket_status != -1){
                tracking.data.bets.forEach(ticket=>{
                    if(this.ticket_status == 2){
                        if(ticket.status==2 || ticket.status==5 || ticket.status==3){
                            filtered.push(ticket);
                        }
                    }
                    else{
                        if(ticket.status==this.ticket_status){
                            filtered.push(ticket);
                        }
                    }
                });
                this.filtered_tracking = filtered;
            }
            else{
                // this.filtered_tracking = tracking.data.bets;
                this.filtered_tracking = tracking.data.bets.filter(ticket => ticket.status !== 0);
            }
        },
        hover: function (id) {
            document.getElementById(id).classList.add('hover');
        },
        hover2: function (id) {
            document.getElementById(id).classList.remove('hover');
        },
        select_status(status){
            clearInterval(this.interval);
            this.ticket_status = status;
            let self = this;
            if(this.ticket_status==-1 || this.ticket_status == 1){
                this.interval = setInterval(function(){
                    self.get_tracking('');
                },60000)
            }
            this.get_tracking('from_scratch');
        },
        translate(text) {
            if(text){
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else{
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    },
    mounted(){
        let dateFrom = new Date();
        dateFrom.setDate(dateFrom.getDate());
        let dateTo = new Date();
        dateTo.setDate(dateTo.getDate());
        this.date_range=[dateFrom,dateTo];
        this.get_tracking('');
        let self = this;
        this.interval = setInterval(function(){
            self.get_tracking('');
        },60000)
    },
    destroyed(){
        clearInterval(this.interval);
    }
}
</script>

<style scoped>
.hover{
    background-color: var(--fondoH) !important;
    color:var(--textH) !important;
}
</style>